export default __webpack_public_path__ + "static/media/26.37feef0d.jpg";